import React from "react";
import { FaFilter } from "react-icons/fa";
import Dropdown from "../../Components/DropDown";

const months = [
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => {
  const y = currentYear - i;
  return { label: y, value: String(y) };
});

const EarningFilter = ({ value, onChange }) => {
  return (
    <Dropdown label="Filter by" icon={FaFilter}>
      {(close) => (
        <div className="py-2 w-40">

          {/* Month */}
          <div className="px-3 py-2">
            <p className="text-xs font-semibold text-gray-500 mb-2">Month</p>
            <select
              value={value?.month || ""}
              onChange={(e) => {
                onChange({
                  ...value,
                  month: e.target.value,
                });
                close();
              }}
              className="w-full border rounded-md px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Months</option>
              {months.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>

          {/* Year */}
          <div className="px-3 py-2">
            <p className="text-xs font-semibold text-gray-500 mb-2">Year</p>
            <select
              value={value?.year || ""}
              onChange={(e) => {
                onChange({
                  ...value,
                  year: e.target.value,
                });
                close();
              }}
              className="w-full border rounded-md px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Years</option>
              {years.map((y) => (
                <option key={y.value} value={y.value}>
                  {y.label}
                </option>
              ))}
            </select>
          </div>

          <div className="border-t my-2" />

          {/* Clear Filters */}
          <button
            className="w-full text-left px-4 py-2 text-sm text-gray-500 hover:bg-gray-100"
            onClick={() => {
              onChange({
                month: "",
                year: "",
              });
              close();
            }}
          >
            Clear filters
          </button>

        </div>
      )}
    </Dropdown>
  );
};

export default EarningFilter;